import axios from 'axios';
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto';
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.use(VueScrollTo);
// Vue.prototype.$store = store

new Vue({
  router,
  data () {
    return {
      survey: {}
    }
  },
  render: h => h(App),
}).$mount('#app')
